export const authorTranslatedStoryTypes = [
  'benzinga_wire_portuguese',
  'benzinga_wire_turkish',
  'benzinga_wire_chinese_simplified',
  'benzinga_wire_arabic',
  'benzinga_wire_german',
  'benzinga_wire_indonesian',
  'benzinga_wire_portuguese',
  'benzinga_wire_turkish',
  'benzinga_wire_espanol',
  'benzinga_wire_spanish',
  'benzinga_wire_italia',
  'benzinga_wire_italian',
  'benzinga_wire_france',
  'benzinga_wire_french',
  'benzinga_wire_korea',
  'benzinga_wire_korean',
  'benzinga_wire_japan',
  'benzinga_wire_japanese',
];

export const translatedContentLanguages = [
  { code: 'pt', name: 'portuguese', storyType: 'benzinga_wire_portuguese' },
  { code: 'tr', name: 'turkish', storyType: 'benzinga_wire_turkish' },
  { code: 'zh-Hans', name: 'chinese_simplified', storyType: 'benzinga_wire_chinese_simplified' },
  { code: 'ar', name: 'arabic', storyType: 'benzinga_wire_arabic' },
  { code: 'es', name: 'spanish', storyType: 'benzinga_wire_spanish' },
  { code: 'fr', name: 'french', storyType: 'benzinga_wire_french' },
  { code: 'gr', name: 'german', storyType: 'benzinga_wire_german' },
  { code: 'id', name: 'indonesian', storyType: 'benzinga_wire_indonesian' },
  { code: 'ja', name: 'japanese', storyType: 'benzinga_wire_japanese' },
  { code: 'kr', name: 'korean', storyType: 'benzinga_wire_korean' },
  { code: 'es', name: 'espanol', storyType: 'benzinga_wire_espanol' },
  { code: 'it', name: 'italia', storyType: 'benzinga_wire_italia' },
  { code: 'itn', name: 'italian', storyType: 'benzinga_wire_italian' },
  { code: 'fr', name: 'france', storyType: 'benzinga_wire_france' },
];

export const PARTNER_CONTENT = 802151;
export const BENZINGA_INSIGHTS = 178351;
export const BENZINGA_NEWSDESK = 80598;
